import {
  RiTimeLine,
  RiArrowDownLine,
  RiAlertLine,
  RiFlightTakeoffLine
} from "@remixicon/react";
import SummaryCard from "./SummaryCard";

/**
 * SummaryCards Component
 * Displays 4 summary statistic cards
 */
const SummaryCards = ({ stats }) => {
  const cards = [
    {
      label: "In flight / Ready",
      value: stats?.inFlight || 0,
      icon:  RiFlightTakeoffLine,
      iconBg: "bg-green-100",
      iconColor: "text-green-600",
      textColor: "text-gray-900",
    },
    {
      label: "Within 48 hours",
      value: stats?.within48Hours || 0,
      icon: RiTimeLine,
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
      textColor: "text-gray-900",
    },
    {
      label: "Low TrustScore",
      value: stats?.lowTrustScore || 0,
      icon: RiArrowDownLine,
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-600",
      textColor: "text-gray-900",
    },
    {
      label: "AOG Incident",
      value: stats?.aogIncidents || 0,
      icon: RiAlertLine,
      iconBg: "bg-red-100",
      iconColor: "text-red-600",
      textColor: "text-gray-900",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3">
      {cards.map((card, index) => (
        <SummaryCard
          key={index}
          label={card.label}
          value={card.value}
          icon={card.icon}
          iconBg={card.iconBg}
          iconColor={card.iconColor}
          textColor={card.textColor}
        />
      ))}
    </div>
  );
};

export default SummaryCards;
